export const PASSWORD_RULES = [
  { key: "lower", label: "Kleinbuchstabe", test: (v) => /[a-z]/.test(v) },
  { key: "upper", label: "Großbuchstabe", test: (v) => /[A-Z]/.test(v) },
  { key: "digit", label: "Zahl", test: (v) => /\d/.test(v) },
  { key: "special", label: "Sonderzeichen", test: (v) => /[^a-zA-Z0-9]/.test(v) },
  { key: "length", label: "Mindestens 8 Zeichen", test: (v) => v.length >= 8 },
];
